module.exports = __webpack_public_path__ + "img/soulmission.8ed938c4.png";